var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"d-flex-column align-center justify-center ma-auto",attrs:{"cols":"6"}},[_c('ParentInfoRow',{attrs:{"number":1}}),_c('ParentInfoRow',{attrs:{"number":2}}),_c('ParentInfoRow',{attrs:{"number":3}}),_c('ParentInfoRow',{attrs:{"number":4}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }